import { z } from 'zod';
import { CHAT_MAX_LENGTH, CHAT_PAGE_SIZE, CHAT_PAGE_SIZE_MAX } from '../constants.js';
export const dmSendSchema = z.object({
    toUserId: z.string().min(1).max(64),
    body: z.string().trim().min(1).max(CHAT_MAX_LENGTH),
});
export const dmHistorySchema = z.object({
    peerUserId: z.string().min(1).max(64),
    beforeId: z.number().int().positive().optional(),
    limit: z.number().int().min(1).max(CHAT_PAGE_SIZE_MAX).default(CHAT_PAGE_SIZE),
});
export const dmReadSchema = z.object({
    peerUserId: z.string().min(1).max(64),
});
//# sourceMappingURL=dmSchema.js.map